import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type CreditLimit = {
  id: string
  dateLastApproval?: Date | null
  businessPartnerId: string
  businessPartnerDescription?: string | null
  statusId: string
  statusDescription?: string | null
  userId: string
  userName?: string | null
  salesRepresentativeId: string
  salesRepresentativeDescription?: string | null
  currencyId: string
  currentCreditLimit: number
  comercialProposedValue: number
  currentCreditLimitBalance: number
  currentPaymentTerm: number
  comercialProposedPaymentTerm: number
  auditedFinancialStatement: boolean
  createdDate: Date
  financialProposedValue: number
  sapValue: number
  sapPaymentTerm: number
  code?: number | null
  businessPartnerChildId?: string | null
  businessPartnerChildDescription?: string | null
  creditLimitType?: string | null
  canDelete?: boolean
  canSend?: boolean
  canApprove?: boolean
  canRead: boolean
  canWrite: boolean
}

export const creditLimitInitialValues: CreditLimit = {
  id: '',
  dateLastApproval: null,
  businessPartnerId: '',
  businessPartnerDescription: null,
  statusId: '',
  statusDescription: null,
  userId: '',
  userName: null,
  salesRepresentativeId: '',
  salesRepresentativeDescription: null,
  currencyId: '',
  currentCreditLimit: 0,
  comercialProposedValue: 0,
  currentCreditLimitBalance: 0,
  currentPaymentTerm: 0,
  comercialProposedPaymentTerm: 0,
  auditedFinancialStatement: false,
  createdDate: new Date(),
  financialProposedValue: 0,
  sapValue: 0,
  sapPaymentTerm: 0,
  code: null,
  businessPartnerChildId: null,
  businessPartnerChildDescription: null,
  creditLimitType: null,
  canRead: false,
  canWrite: false,
}

type CreditLimitStore = {
  creditLimits: CreditLimit[]
  resetCreditLimits: () => void
  setCreditLimits: (creditLimit: CreditLimit[]) => void
  updateCreditLimitsStored: (creditLimit: CreditLimit) => void
  findCreditLimitById: (id: string) => CreditLimit | undefined
}

export const useCreditLimitStore = create<CreditLimitStore>()(
  persist(
    (set, get) => ({
      creditLimits: [],
      resetCreditLimits: () => set(() => ({ creditLimits: [] })),
      setCreditLimits: (creditLimits: CreditLimit[]) =>
        set(() => ({ creditLimits })),
      findCreditLimitById: (id: string) => {
        const { creditLimits } = get()
        return creditLimits.find(
          (creditLimit: CreditLimit) => creditLimit.id === id
        )
      },
      updateCreditLimitsStored: (creditLimit: CreditLimit) =>
        set((state) => ({
          creditLimits: state.creditLimits.map((el) => {
            if (el.id === creditLimit.id) {
              return creditLimit
            }
            return el
          }),
        })),
    }),
    {
      name: 'credit-limit-order-storage',
      storage: encryptedStorage(),
    }
  )
)
